// Shared numeric-tile primitive. `MetricCard`/`StatCard` were duplicated
// locally in `AdminOrgDetail.tsx` and `AdminOverview.tsx`; `AdminAnalytics.tsx`
// would have been a third near-identical copy, so this is the extraction.
// The two existing local copies are left as-is — retrofitting them is a
// separate, optional cleanup, not required for the analytics page.

export function MetricCard({
  label,
  value,
  sublabel,
  loading,
}: {
  label: string;
  value: number | string;
  sublabel?: string | undefined;
  loading?: boolean | undefined;
}) {
  return (
    <div className="rounded-lg border border-border bg-background p-4">
      <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">{label}</p>
      <p className="mt-2 text-2xl font-semibold tracking-tight">
        {loading ? <span className="text-muted-foreground">—</span> : value}
      </p>
      {sublabel ? <p className="mt-1 text-xs text-muted-foreground">{sublabel}</p> : null}
    </div>
  );
}
